// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/profile-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .twofa-guide-wrapper {
  padding-top: 80px;
} */

/* .navbar-space-wrapper{
  padding-top: 80px;
} */

.twofa-mobile-header {
  display: none;
}

h2.twofa-status-desabled{
  color: #FF360D !important;
}

.authnticator-icon-wrap{
  margin-bottom: 60px;
}

p.twofa-status.status-text {
  font-size: 30px;
  color: #383838;
}

.twofa-guide-wrapper {
  /* height: 100vh; */
}

.twofa-header {
  text-align: center;
  padding-top: 20px;
  /* border-bottom: 1px solid #858585; */
}

.twofa-header h3 {
  font-size: 28px;
  color: #383838;
}

.twofa-enable-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  margin-top: 25px;
  padding-bottom: 200px;
}

.twofa-enable-wrapper img {
  width: 120px;
  height: 120px;
}

.twofa-enable-wrapper h4 {
  /* color: #383838; */
  /* font-size: 20px; */
}

.twofa-enable-wrapper p {
  font-size: 15px;
  color: #717171;
}

.download-authenticator-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.download-authenticator-wrap .playstore img {
  width: 80px;
  height: auto;
}

.twofa-security-wrap img {
  width: 30px;
  height: 30px;
}

.twofa-security-wrap {
  display: flex;
  /* align-items: center; */
  justify-content: center;
  gap: 10px;
  width: 360px;
  text-align: center;
}

.twofa-security-wrap img {
  margin-top: 6px;
}

.twofa-security-wrapper {
  /* padding-bottom: 20px; */
  border-bottom: 1px solid #858585;
}

.twofa-security-wrap p {
  margin: 0px;
  color: #717171;
  font-size: 13px;
}

.twofa-icons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 20px;
}


.twofa-icons {
  position: absolute;
  right: 0;
  bottom: 0;
}

.icons {
  width: 20px;
  height: 20px;
  background: #d2d2d2;
  border-radius: 50%;
}

.active-icon {
  background: #00A19B !important;
}

.twofa-guide-button img {
  width: 50px;
  height: 10px;
}
.twofa-guide-button button {
  background: #00A19B;
  border-radius: 10px;
  opacity: 1;
  border: none;
  color: #FFFFFF;
  padding: 10px 40px;
  font-size: 15px;
  font-weight: 600;
  width: 651px;
  height: 71px;
}

.ip-button {
  margin-bottom: 15px;
}

.twofa-guide-button button:hover {
  background-color: #fff;
  color: #071224;
  border: 2px solid #00A19B;
}

.qr-code-image img {
  width: 200px;
  height: 200px;
  margin-top: 20px;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #cccccc30;
}

.qr-code-image {
  padding: 40px 0px;
}

.twofa-backup-secret {
  text-align: center;
  /* max-width: 400px; */
}

.security-code-text {
  text-align: center;
}

.security-code-text h3 {
  font-size: 20px;
  color: #383838;
  padding: 40px 0px;
}

.security-code-text input {
  height: 40px;
  width: 250px;
  border-radius: 8px;
  border: 1px solid #707070;
  outline: none;
  font-size: 13px;
  padding: 10px;
  margin-bottom: 40px;
  color: #717171;
}

.input {
  position: relative;
}

.security-code-text img {
  width: 17px;
  height: 18px;
  position: absolute;
  right: 10px;
  top: 10px;
}

.twofa-guide-button {
  text-align: center;
  margin-top: 5px;
  margin-bottom: 12px;
}

.twofa-footer {
  position: fixed;
  bottom: 30px;
  background: #fff !important;
}

.twofa-status-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.twofa-status-wrapper img {
  width: 100px;
  height: 100px;
}

.twofa-status-wrapper p {
  font-size: 22px;
  color: #383838;
  /* margin: 0px; */
  margin-top: 15px !important;
  margin-bottom: 0px;
}

.twofa-status-wrapper h2 {
  font-size: 32px;
  color: #00A19B;
  font-weight: 500;
}

h2.disable-request {
  color: #FF360D;
}

.disable-btn {
  padding-bottom: 50px;
}

.disable-btn button {
  background: var(--buttonColor);
  border-radius: 5px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 7px 26px;
  font-size: 15px;
  font-weight: 600;
}

.confirm-button-wrap button {
  background: #00A19B;
  border-radius: 10px;
  opacity: 1;
  border: none;
  color: #FFFFFF;
  padding: 8px 40px;
  font-size: 15px;
  font-weight: 600;
  height: 65px;
  width: 100%;
}

.confirm-button-wrap button:hover {
  background-color: #fff;
  border: 2px solid #00A19B;
  color: #071224;
}

.confirm-button-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-bottom: 10px;
}

button.cancel-button {
  background: #9b9b9b;
  border-radius: 10px;
  opacity: 1;
  border: none;
  color: #383838;
  padding: 8px 40px;
  margin-top: 20px;
  font-weight: 600;
}

.resend-email-btn button {
  background: #00A19B;
  border-radius: 10px;
  opacity: 1;
  border: none;
  color: #fff;
  padding: 8px 40px;
  height: 49px;
  margin-top: 20px;
  font-weight: 500;
}


button.cancel-button:hover {
  background: #FFFFFF;
  border: 2px solid #CBCBCB;
}

.receive-security-key {
  position: relative;
}

.receive-security-key input {
  width: 100%;
  padding: 18px 10px;
  width: 380px;
  border: 1px solid #707070;
  border-radius: 8px;
  outline: none;
  color: #717171;
  font-size: 17px;
  position: relative;
}

.input-box {
  padding: 22px 30px;
  width: 550px;
  height: 70px;
  background-color: #F8F8F8;
  border: none;
  border-radius: 10px
}

.input-box p {
  font-size: 15px;
  width: 265px;
  overflow: hidden;
  margin: 0px;
}

.copy-btn img {
  width: 20px;
  position: absolute;
  top: -34px;
  right: 17px;
  border: 0;
  cursor: pointer;
}

.receive-security-key input:focus {
  display: none;
}


.twofa-guide-header-content {
  display: flex;
  align-items: center;
  gap: 10px;
}

.twofa-guide-header-content img{
  width: 58px !important;
}


.twofa-guide-wrapper .container {
  position: relative;
  /* min-height: 95vh; */
}


.disable-twofa-input-wrap{
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.disable-twofa-input-wrap input[type=checkbox]{
    height: 0;
    width: 0;
    visibility: hidden;
}

.disable-twofa-input-wrap label {
    cursor: pointer;
    text-indent: -9999px;
  width: 150px;
  height: 72px;
    background: #F8F8F8;
    display: block;
    border-radius: 100px;
    position: relative;
}

.disable-twofa-input-wrap label:after {
    content: '';
    position: absolute;
    top: 12px;
    left: 10px;
  width: 50px;
  height: 50px;
    background: #BFBFBF;
    border-radius: 90px;
    transition: 0.3s;
}


.disable-twofa-input-wrap input:checked + label:after {
    left: calc(100% - 10px);
    transform: translateX(-100%);
  background: #00A19B !important;
}

.disable-twofa-input-wrap label:active:after {
    width: 130px;
}


.disable-twofa-input-wrap p{
  font-size: 24px;
  color: #717171;
}

.twofa-security-wrap input {
  width: 50px;
  height: 36px;
  cursor: pointer;
}


.admin-sidebar-space{
  margin-left: 140px;
}

@media (max-width: 1024px) {
  .twofa-icons{
    display: none;
  }

  .twofa-enable-wrapper img {
    width: 130px;
    height: auto;
}

  .copy-btn img {
    width: 20px;
    height: 20px;
    top: 25px;
  }

.twofa-security-wrap img {
  width: 23px;
  height: 23px;
}

  .twofa-enable-wrapper h4 {
    color: #383838;
    font-size: 20px;
    margin-top: 50px;
    margin-bottom: 0px;
  }

  h4.get-appstore-playstore {
    font-size: 18px;
    font-weight: 400;
  }

  .twofa-enable-wrapper p {
    font-size: 24px;
    font-weight: 500;
  }

  .twofa-status-wrapper h2 {
    font-size: 36px;
  }

  .disable-twofa-input-wrap p {
    font-size: 18px;
  }
  
  h2.disable-request {
    margin-top: 60px;
  }

  .disable-twofa-input-wrap label {
    width: 140px;
    height: 62px;
  }

  .disable-twofa-input-wrap label:after {
    width: 35px;
    height: 35px;
  }

  .security-code-text{
    text-align: left;
    margin-top: 100px;
  }

  .security-code-text h3 {
    font-size: 20px;
    color: #383838;
    padding: 0px 0px;
}

.pin-code-twofa input {
  width: 60px;
  height: 60px;
  font-size: 36px;
  margin-right: 2px;
}
}


@media (max-width: 767px) {
  /* .twofa-header h3 {
    display: none;
  } */

  p.twofa-status.status-text {
    font-size: 25px;
  }

  .twofa-desktop {
    display: none;
  }

  .receive-security-key {
    width: 98%;
  }

  .receive-security-key input {
    padding: 18px 10px;
    width: 100%;
    border: 1px solid #707070;
    border-radius: 8px;
    outline: none;
    position: relative;
  }

  .input-box {
    padding: 18px 30px;
    width: 100%;
    border-radius: 10px;
    outline: none;
    position: relative;
  }

  .input-box p {
    font-size: 18px;
    width: 81%;
    text-align: left !important;
    overflow: hidden;
    margin-top: 3px;
  }

  .copy-btn img {
    width: 20px;
    position: absolute;
    top: -28px;
    right: 17px;
    border: 0;
    cursor: pointer;
    z-index: 99;
  }

  .twofa-mobile-header {
    font-size: 24px !important;
    color: #383838;
    display: block !important;
  }

  .twofa-security-wrapper {
    padding-bottom: 20px;
    border-bottom: 1px solid #858585;
    width: 100%;
    margin: 0 auto;
  }

  .twofa-enable-wrapper {
    gap: 12px;
    margin-top: 20px;
  }

  .download-authenticator-wrap .playstore img {
    width: 65px;
    height: auto;
  }

  /* .twofa-enable-wrapper img {
    width: 100px;
    height: 100px;
  } */

  img.scanner-img {
    width: 170px;
    height: 170px;
    margin-top: 10px;
  }

  .twofa-guide-button img {
    width: 50px;
    height: 10px;
  }

  .twofa-security-wrap img {
    width: 30px;
    height: 30px;
  }

  .twofa-security-wrap {
    width: 100%;
  }

  .twofa-enable-wrapper p {
    margin: 0px;
    font-size: 18px;
    width: 90%;
    text-align: center;
  }

  p.twofa-status {
    font-size: 22px;
    font-weight: 500;
}

  .twofa-status-wrapper h2 {
    font-size: 32px;
  }

  .disable-twofa-input-wrap p {
    font-size: 14px;
  }

  .twofa-enable-wrapper {
    margin-top: 50px !important;
  }

  /* .twofa-enable-wrapper img {
    width: 110px;
    height: 144px;
  } */

  .copy-btn img {
    width: 20px;
    height: 20px;
    top: 25px;
  }


  .authnticator-icon-wrap {
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .twofa-enable-wrapper h4 {
    color: #383838;
    font-size: 20px;
    margin-top: 40px;
    margin-bottom: 0px;
  }

  h4.get-appstore-playstore {
    font-size: 18px;
    font-weight: 400;
  }

  .twofa-header h3 {
    font-size: 25px;
    color: #383838;
  }

  .security-code-text img {
    width: 17px;
    height: 18px;
  }

  h2.disable-request {
    color: #ff360d;
    font-size: 30px;
    margin-top: 14px;
  }

  .twofa-footer {
    position: unset;
    margin-top: 40px !important;
    background: #fff !important;
    padding-bottom: 5px;
  }

  .twofa-guide-header-content img {
    display: none;
  }

  .twofa-icons {
    display: none;
  }

  p.download-2fa {
    font-size: 18px;
    color: #383838;
    margin-top: 12px;
}

  p.twofa-auth-code-text{
    font-size: 20px;
    color: #383838;
    margin-top: 20px;
  }

  .qr-code-image {
    padding: 30px 0px;
  }

  .security-code-text{
    text-align: left;
    margin-top: 100px;
  }

  .security-code-text h3{
    padding: 0px;
  }


  .pin-code-twofa input{
    width: 50px !important;
    height: 50px !important;
  }

  .twofa-security-wrap input {
    width: 22px;
    height: 30px;
  }

}



@media (max-width: 380px) {
  .pin-code-twofa input{
    width: 45px !important;
    height: 48px !important;
  }
}

@media (min-width: 1800px) and (max-width: 2100px) {
  /* .twofa-footer {
    position: absolute;
    bottom: 150px;
  } */

  .twofa-footer {
    position: fixed;
    bottom: 10px !important;
  }
}

@media (min-width: 2100px) {
  .twofa-footer {
    position: fixed;
    bottom: 10px !important;
  }
}

@media (min-width: 1600px) {
  .download-authenticator-wrap {
    padding: 10px 0px 20px 0px;
  }

  .disable-btn {
    padding-bottom: 10px;
  }

  .twofa-security-wrap {
    width: 650px;
    text-align: left;
    padding-bottom: 24px;
  }

  .qr-code-image {
    padding: 60px 0px;
  }

  .twofa-security-wrap p {
    font-size: 18px;
  }

  .twofa-enable-wrapper p {
    font-size: 18px;
    color: #717171;
  }

  p.twofa-auth-code-text {
    font-size: 28px;
    color: #383838;
}

  .twofa-header h3 {
    font-size: 38px;
  }

  .twofa-guide-button button {
    margin-top: 20px;
  }

  .twofa-guide-button img {
    width: 80px;
    height: 12px;
  }

  .download-authenticator-wrap .playstore img {
    width: 86px;
    height: 86px;
  }

  .twofa-footer {
    position: fixed;
    bottom: 10px !important;
  }

  .twofa-enable-wrapper img {
    width: 138px;
    height: 170px;
}


  .authnticator-icon-wrap img {
    width: 300px;
    height: 300px;
  }

  .twofa-security-wrap img {
    width: 30px;
    height: 30px;
  }

  .twofa-guide-button img {
    width: 80px;
    height: 12px;
  }

  .twofa-enable-wrapper {
    gap: 10px;
  }

  .security-code-text img {
    width: 17px;
    height: 18px;
  }

  img.scanner-img {
    width: 300px !important;
    height: 300px !important;
    margin-top: 0px;
  }

  .security-code-text h3 {
    font-size: 28px;
    text-align: left;
    padding: 10px 0px;
  }



  .input-box {
    /* height: 55px; */
    padding: 22px 30px;
    width: 651px;
    height: 70px;
    background-color: #F8F8F8;
    border: none;
  }

  .input-box p {
    font-size: 20px;
    width: 275px;
    overflow: hidden;
    /* margin-top: 13px; */
  }

  .security-code-text {
    text-align: center;
    margin: 55px 0px;
  }

  .security-code-text img {
    top: 16px;
  }

  .auth-input {
    margin: 180px 0px;
  }

  /* .twofa-status-wrapper {
    margin-top: 100px;
  } */

  .twofa-status-wrapper h2 {
    font-size: 50px;
    padding-top: 0px;
  }



  h2.disable-request {
    padding-top: 100px;

  }

  p.twofa-status {
    font-size: 38px;
    color: #383838;
    font-weight: 500;
  }

  .copy-btn img {
    width: 25px;
    height: 25px;
    position: absolute;
    top: 20px;
    right: 30px;
    border: 0;
    cursor: pointer;
  }

  p.download-2fa {
    font-size: 22px;
    color: #383838;
  }

  .twofa-status-wrapper {
    margin-top: 80px;
  }


  .dashboard-twofa-enable-wrapper{
    margin-top: 0px;
  }

  .dashboard-twofa-enable-wrapper .twofa-status-wrapper{
    margin-top: 36px;
  }

  .reivew-wrap {
    margin-top: 20px;
  }

  .reivew-wrap img {
    width: 30px;
    height: auto;
  }


}

.reivew-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.reivew-wrap p {
  margin: 0px !important;
}

.reivew-wrap img {
  width: 30px;
  height: auto;
}

p.review-time {
  font-size: 17px;
  color: #717171;
}

p.user-alert-text {
  font-size: 16px;
  text-align: center;
  color: #717171;
  margin-bottom: 30px;
}


p.download-2fa {
  color: #383838;
}

.twofa-auth-code-text {
  color: #383838;
}

@media (min-width: 1024px) and (max-width: 1599px) {
  .enable-pin-code-twofa .pin-code-twofa input {
    width: 60px !important;
    height: 60px !important;
    font-size: 20px !important;
    margin-right: 2px;
  }

  .twofa-enable-wrapper h4 {
    font-size: 24px;
    margin-top: 20px;
    margin-bottom: 0px;
  }

  .twofa-guide-header-content img {
    width: 42px !important;
  }

  .authnticator-icon-wrap {
    margin-bottom: -20px;
    margin-top: -30px;
  }

  .download-authenticator-wrap .playstore img {
    width: 70px;
    height: auto;
  }

  h4.get-appstore-playstore {
    font-size: 18px;
    font-weight: 400;
  }

  .twofa-enable-wrapper img {
    width: 80px;
    height: 100px;
  }

  .copy-btn img {
    width: 24px;
    height: 24px;
    top: 18px;
  }


  .qr-code-image img {
    width: 220px;
    height: 220px;
    margin-top: 10px;
  }

  .twofa-security-wrap img {
    width: 24px;
    height: 24px;
  }

  .reivew-wrap img {
    width: 30px;
    height: auto;
  }


  .twofa-enable-wrapper p {
    font-size: 22px;
    font-weight: 500;
    margin-top: 2px !important;
  }

  .input-box p {
    font-size: 20px;
    margin-top: -2px !important;
  }

  .copy-btn p {
    font-size: 20px;
  }

  .receive-security-key p {
    font-size: 18px;
  }

  .twofa-enable-wrapper .twofa-status-wrapper h2 {
    font-size: 32px;
  }

  h2.disable-request {
    margin-top: 60px;
  }

  .disable-twofa-input-wrap p {
    font-size: 20px;
  }

  .qr-code-image {
    padding-top: 2px;
    padding-bottom: 20px;
  }

  .input-box {
    padding: 18px 30px;
    width: 550px;
    height: 65px;
    background-color: #F8F8F8;
    border: none;
  }

  p.download-2fa {
    font-size: 22px;
    color: #383838;
    font-weight: 400;
    margin: 0px;
  }


  p.twofa-auth-code-text {
    font-size: 22px;
    color: #383838;
    font-weight: 400;
}


.security-code-text {
  text-align: left;
  margin-top: 70px;
}

.security-code-text h3 {
  font-size: 24px;
  padding: 10px 0px;
}

.disable-twofa-input-wrap label {
  width: 120px;
  height: 48px;
}

.disable-twofa-input-wrap p {
  font-size: 16px !important;
  color: #717171;
}

.disable-twofa-input-wrap label:after {
  width: 28px;
  height: 28px;
}

.disable-twofa-input-wrap label:after {
  top: 10px;
}

.twofa-enable-wrapper .twofa-status-wrapper {
  margin: 30px;
}

.twofa-security-wrap input {
  width: 50px;
  height: 40px;
}

}

.confirm-button-wrap {
  padding-bottom: 10px;
}


button.disabled-button {
  background: #E1E1E1 !important;
  color: #ffff;
  cursor: no-drop;
}


button.disabled-button:hover {
  background: #E1E1E1 !important;
  border: none !important;
  color: #ffff !important;
  cursor: no-drop;
}

/************** ChangeSecurity css import here *********/
.change-pin-wrapper {
  padding-top: 80px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed;
  min-height: 100vh;
}

.change-principle-active {
  border-bottom: 4px solid var(--buttonColor);
  width: 85px;
  text-align: center;
}

.change-principle-active:hover {
  border-bottom: 4px solid var(--buttonHover);
  width: 85px;
  text-align: center;
}

.change-pin-wraper {
  /* padding-bottom: 220px; */
  /* overflow: scroll; */
}

.login-change-form .field {
  position: relative;
  width: 100%;
  background: #F8F8F8;
  border-radius: 10px;
  margin-bottom: 12px;
}

.twofa-header {
  text-align: center;
  padding-top: 20px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 10px;
}

.twofa-header h3 {
  font-size: 28px;
  color: #383838;
}

.change-pin-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  padding-top: 20px;
}

.change-login-active {
  border-bottom: 4px solid var(--buttonColor);
  width: 170px;
  text-align: center;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
  }
}

.change-login-active:hover {
  border-bottom: 4px solid var(--buttonHover);
  width: 170px;
  text-align: center;
}

.must-contain-wrapper {
  /* text-align: center; */
  background: #F8FBFE;
  width: 400px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 20px;
  border-radius: 19px;
  min-height: 150px;
}

.list-icon {
  width: 10px;
  height: 10px;
  border-radius: 100%;
  background: #00A19B;
}

.list {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.list p {
  font-size: 16px;
  margin: 0px;
  color: #717171;
}

.kyc-requirement-wrapper {
  /* text-align: center; */
  width: 400px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 20px;
  box-shadow: 0px 3px 6px #0000001a;
  border: 2px solid #4d9798;
  border-radius: 19px;
  min-height: 150px;
}

.requirement-wrapper {
  padding: 20px;
  width: 100%;
  margin-left: 30px;
}

.requirement-wrap p {
  font-size: 22px;
  color: #717171;
  margin: 0px;
}

.requirement-wrap img {
  width: 25px;
}

img.selfie-img {
  width: 20px !important;
  margin-right: 10px;
}

.requirement-wrap {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  gap: 20px;
  margin-bottom: 28px;
}

p.kyc-text {
  font-size: 18px;
  width: 500px;
  color: #383838;
  margin: 0 auto;
  text-align: center;
  margin-top: 25px;
  margin-bottom: 40px;
}

.login-change-form {
  width: 400px;
  margin: 0 auto;
  margin-top: 30px;
}

/* .login-change-form input {
  width: 100%;
  margin-bottom: 15px;
  border: 1px solid #707070;
  border-radius: 6px;
  outline: none;
  font-size: 14px;
  color: #707070;
  z-index: unset;
} */

.login-change-form input {
  width: 100%;
  border: none;
  background: #F8F8F8;
  outline: none;
  font-size: 14px;
  color: #707070;
  z-index: 22;
  position: relative;
  background: none;
  outline: none;
  box-shadow: none;
}

.kyc-requirement-info-wrapper h3 {
  text-align: center;
  margin-top: 80px;
  color: #383838;
  font-size: 24px;
}

.change-login h2 {
  font-size: 20px;
  color: #858585;
  cursor: pointer;
}

h2.active-login {
  font-size: 20px;
  color: #383838 !important;
  cursor: pointer;
}

.list-wrapper {
  /* width: 200px;
  margin: 0 auto;
  padding: 15px; */
  padding: 28px 50px;
}

.must-contain-wrapper h3 {
  font-size: 18px;
  color: #383838;
  padding-bottom: 16px;
}

@media (max-width: 767px) {
  p.kyc-text {
    font-size: 16px;
    width: 100%;
  }

  .login-confirm-pin {
    margin-top: 100px;
  }

  .secured-pin-wrap {
    margin-bottom: 100px !important;
  }

  .change-login-active {
    border-bottom: 3px solid var(--buttonColor);
    width: 140px;
  }

  .change-login-active:hover {
    border-bottom: 3px solid var(--buttonHover);
    width: 140px;
    text-align: center;
  }

  .kyc-requirement-wrapper {
    width: 100%;
    height: 250px;
  }

  .kyc-requirement-info-wrapper h3 {
    text-align: center;
    margin-top: 50px;
  }


  .must-contain-wrapper {
    width: 100%;
  }

  .login-change-form {
    width: 100%;
  }

  h2.active-login {
    font-size: 24px;
    color: #383838 !important;
  }

  .change-login h2 {
    /* font-size: 24px; */
    font-size: 17px;
    color: #858585;
  }

  .list p {
    font-size: 18px;
    margin: 0px;
  }

  .list {
    gap: 15px;
    margin-bottom: 10px;
  }

  .list-wrapper {
    padding: 30px;
  }

  .list-icon {
    width: 14px;
    height: 14px;
  }

  .must-contain-wrapper {
    margin-top: 30px;
  }

  .twofa-header {
    padding-top: 20px;
    padding-bottom: 10px;
    height: 78px;
  }

  .twofa-header h3 {
    font-size: 30px;
    color: #383838;
  }

  .login-change-form.password-change {
    margin-top: 40px;
  }

  /* .login-change-form input {
    margin-bottom: 15px;
  } */

  .twofa-security-wrap p {
    font-size: 14px;
    text-align: left;
  }

  .pin-code input {
    border: 1px solid #707070;
    text-align: center;
    /* width: 60px !important;
    height: 60px !important; */
    margin-right: 15px !important;
    font-size: 36px;
    background-color: #fff;
  }

  .must-contain-wrapper h3 {
    font-size: 20px;
  }

  .login-change-form input {
    width: 100%;
    height: 65px;
  }

  .login-change-form .field label::before {
    top: 20px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .must-contain-wrapper{
    width: 550px;
    min-height: 100px !important;
    margin-top: 10px !important;
    background: unset;
  }

  .list {
    gap: 8px;
    margin-bottom: 0px;
  }

  .list p {
    font-size: 16px;
  }

  .must-contain-wrapper h3 {
    font-size: 22px;
    margin-top: 15px;
    padding-bottom: 8px;
  }

  .login-change-form {
    width: 550px;
    margin-top: 10px;
  }

  .change-pin-list-wrapper {
    width: 200px;
  }


  .password-change {
    margin-top: 60px;
  }

  .pin-code input {
    width: 70px;
    height: 60px;
    margin-right: 10px;
  }

  h2.active-login {
    font-size: 20px;
    color: #383838 !important;
  }

  .change-login h2 {
    font-size: 16px;
    color: #858585;
  }

  .list p {
    font-size: 13px;
    margin: 0px;
  }

  .list p {
    font-size: 15px;
    margin: 0px;
  }

  .list {
    gap: 15px;
    margin-bottom: 10px;
  }

  .list-wrapper {
    padding: 10px;
  }

  .must-contain-wrapper {
    margin-top: 15px;
  }

  .twofa-header {
    padding-top: 8px;
  }

  .twofa-header h3 {
    font-size: 22px;
    color: #383838;
  }

  .login-change-form {
    margin-top: 20px;
    padding-bottom: 180px;
  }

  /* .login-change-form input {
    margin-bottom: 25px;
    padding: 2px 10px;
  } */

  .twofa-security-wrap p {
    font-size: 12px;
  }

  .list-wrap{
    margin-top: 0px;
    gap: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list-wrap-left {
    display: flex;
    gap: 17px;
  }

  .list-wrap-right {
    display: flex;
    gap: 17px;
  }

  .login-change-form input {
    width: 100%;
    height: 65px;
    font-size: 18px;
    padding-left: 30px;
  }

  .list-wrapper {
    padding: 0px;
    text-align: center;
}
}

.login-change-form h2 {
  /* font-family: helvetica; */
  text-align: center;
  font-size: 20px;
  color: #383838;
  margin-top: 20px;
  margin-bottom: 20px;
}

.pin-code {
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}

.pin-code-twofa {
  padding: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.pin-code-twofa input {
  border: none;
  border-radius: 8px;
  outline: none;
  text-align: center;
  width: 80px;
  height: 80px;
  font-size: 36px;
  background-color: #F8F8F8;
  margin-right: 5px;
  color: #383838;
  line-height: normal;
}

.pin-code input {
  border: 1px solid #707070;
  text-align: center;
  width: 48px;
  height: 48px;
  font-size: 36px;
  background-color: #fff;
  margin-right: 5px;
}



input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.show {
  display: block !important;
}

.hide {
  display: none;
}

.table-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  /* transition: 0.5s; */
}


@media (min-width: 1025px) and (max-width: 1599px) {
  .must-contain-wrapper{
    width: 550px;
    min-height: 100px !important;
    margin-top: 10px !important;
    background: unset;
  }

  .list {
    gap: 8px;
    margin-bottom: 0px;
  }

  .list p {
    font-size: 16px;
  }

  .must-contain-wrapper h3 {
    font-size: 22px;
    margin-top: 15px;
    padding-bottom: 8px;
  }

  .login-change-form {
    width: 550px;
    margin-top: 10px;
  }

  .field label::before {
    font-size: 16px;
   left: 30px;
  }

  .pin-code input {
    width: 70px;
    height: 60px;
    margin-right: 10px;
  }


  .kyc-requirement-info-wrapper h3 {
    text-align: center;
    margin-top: 10px;
  }

  p.kyc-text {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .requirement-wrap {
    margin-bottom: 20px;
  }

  .list-wrap{
    margin-top: 0px;
    gap: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .list-wrap-left {
    display: flex;
    gap: 17px;
  }

  .list-wrap-right {
    display: flex;
    gap: 17px;
  }

  .login-change-form input {
    width: 100%;
    height: 65px;
    font-size: 18px;
    padding-left: 30px;
  }

  .list-wrapper {
    padding: 0px;
    text-align: center;
}

.twofa-enable-wrapper {
  margin-top: 0px;
  padding-bottom: 120px;
  gap: 2px;
}

.twofa-footer {
  position: fixed;
  bottom: 10px;
}
  
}

@media (min-width: 1600px) {
  .twofa-header h3 {
    font-size: 45px;
    color: #383838;
  }

  .twofa-header {
    text-align: center;
    padding-top: 29px;
    border-bottom: 1px solid #ccc;
    padding-bottom: 10px;
  }

  .change-login h2 {
    font-size: 24px;
  }

  .change-pin-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 50px;
    padding-top: 25px;
  }

  .must-contain-wrapper h3 {
    font-size: 24px;
    color: #383838;
    font-family: 'Montserrat';
    font-weight: 500;
  }


  .list {
    gap: 20px;
  }

  .list p {
    color: #717171;
    font-size: 20px;
    margin: 0px;
  }

  .list-icon {
    width: 14px;
    height: 14px;
  }

  .login-change-form {
    margin-top: 20px;
  }


  .login-change-form .field {
    height: 80px;
  }

  .must-contain-wrapper {
    width: 650px;
    height: 259px;
  }

  .login-change-form {
    width: 651px;
  }

  .login-change-form h2 {
    font-size: 24px;
    margin-top: 70px;
    margin-bottom: 30px;
  }

  .add-ip-code input {
    width: 80px;
    height: 45px;
  }

  .ip-dot {
    width: 7px;
    height: 7px;
    margin-top: 36px;
  }

  .change-pin-wraper .field label::before {
    content: attr(title);
    position: absolute;
    top: 30px;
    left: 40px;
  }

  .twofa-guide-button button {
    margin-top: 20px;
    font-size: 20px;
  }

  .twofa-enable-wrapper h4 {
    font-size: 28px;
    color: #383838;
    margin-bottom: 0px;
  }

  h4.get-appstore-playstore{
    font-size: 18px;
    color: #717171;
  }

  .download-authenticator-wrap .playstore img {
    width: 86px;
    height: 86px;
  }

  .login-change-form input {
    font-size: 18px;
  }
}

.pin-code-twofa input {
  border-radius: 8px;
  outline: none;
}

@media (max-width: 400px) {
  .pin-code-twofa input {
    border-radius: 8px;
    outline: none;
    text-align: center;
    width: 42px;
    height: 50px;
    font-size: 30px;
    background-color: #F8F8F8;
    margin-right: 0px;
    color: #383838;
  }
}

@media (max-width: 300px) {
  .pin-code-twofa input {
    border: 1px solid #707070;
    border-radius: 8px;
    outline: none;
    text-align: center;
    width: 38px;
    height: 50px;
    font-size: 20px;
    background-color: #fff;
    margin-right: -2px;
    color: #383838;
  }
}

@media (min-width: 1600px) {
  .login-change-form .label-before,
  .login-change-form .field input:focus + label::before,
  .login-change-form .field input:valid + label::before {
    color: #707070;
    line-height: 20px;
    font-size: 18px;
    top: -10px;
  }

  .login-change-form .label {
    font-size: 18px;
  }

  .change-pin-wraper .field label::before {
    font-size: 18px;
  }

  .login-change-form input {
    font-size: 20px;
    margin-top: 8px;
    padding-left: 50px;
    padding-top: 12px;
  }

  .field.up-text label::before {
    color: #707070;
    line-height: 20px;
    font-size: 18px;
    top: -10px;
    background: #fff !important;
    padding: 0 6px;
    left: 9px;
    font-weight: 400;
  }

}



/************ KYC Page css Start Here For more Importance ******/
.change-pin-wrapper{
  padding-top: 0px;
}

.change-password-wrapper{
  padding-top: 80px;
}

/* .navbar-space-wrapper{
  padding-top: 80px;
} */

.kyc-requirement-wrapper {
  /* text-align: center; */
  border: none;
  box-shadow: none;
  width: 400px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 19px;
  min-height: 150px;
  background: #F8FBFE;
  width: 650px;
  height: 376px;
}


p.kyc-text {
  font-size: 28px;
  width: 50%;
  font-family: 'Montserrat';
  color: #383838;
  margin: 0 auto;
  font-weight: 500;
  margin-bottom: 80px;
  margin-top: 35px;
}


.twofa-header.kyc-verification-header {  
  display: flex;
  align-items: center;
  justify-content: space-between;
}


.twofa-header h3 {
  font-size: 38px;
  margin: 0px;
}

.twofa-header.kyc-verification-header img {
  width: 141px;
}


.requirement-wrapper h4 {
  font-size: 22px;
  color: #383838;
  font-family: 'Montserrat';
  font-weight: 500;
  margin-top: 25px;
  margin-bottom:40px;
}


img.kyc-status-review {
  width: 300px;
  height: auto;
}

p.twofa-status.status-text {
  font-size: 40px;
  color: #383838;
  font-family: 'Montserrat';
}


p.review-time {
  font-size: 26px;
  color: #9E9E9E;
}

.twofa-footer.kyc-review-footer .twofa-security-wrapper{
  border-bottom: none;
}



@media(max-width: 767px){
  .kyc-requirement-wrapper {
      width: 85%;
      height: 300px;
  }

  .twofa-guide-button button{
      width: 100%;
      height: 55px;
  }

  p.kyc-text {
      font-size: 18px;
      width: 100%;
      margin-bottom: 90px;
      margin-top: 35px;
  }

  .twofa-header h3 {
      font-size: 24px;
  }

  .twofa-header.kyc-verification-header img {
      width: 94px;
  }

  .requirement-wrap p {
      font-size: 18px;
  }


  .requirement-wrapper h4 {
      font-size: 20px;
      margin-top: 10px;
      margin-bottom: 30px;
  }

  .navbar-space-wrapper {
      padding-top: 80px;
  }

  .change-password-wrapper {
      padding-top: 80px;
  }

  .requirement-wrapper{
      margin-left: 0px;
      margin-bottom: 80px;
  }

  .requirement-wrap {
      margin-bottom: 25px;
  }


  .twofa-guide-button {
      text-align: center;
      margin-top: 20px;
  }

  img.kyc-status-review {
      width: 230px;
      height: auto;
  }

  p.twofa-status.status-text {
      width: 100%;
      font-size: 26px;
  }

  p.review-time {
      font-size: 16px;
  }

  .reivew-wrap{
      margin-top: 14px;
  }

  .reivew-wrap img {
      width: 20px;
      height: auto;
  }

  .twofa-security-wrap img {
      width: 23px;
      height: 23px;
  }


  .reivew-wrap {
      gap: 8px;
      /* margin-top: -24px; */
  }

  .twofa-status-wrapper {
      margin-bottom: 60px;
  }

  .kyc-decline-space{
      margin-bottom: 120px;
  }
}

@media (min-width: 768px) and (max-width: 1024px){
  p.kyc-text {
      font-size: 20px;
      width: 70%;
      margin-bottom: 30px;
      margin-top: 20px;
  }

  .requirement-wrap {
      margin-bottom: 22px;
  }

  .kyc-requirement-wrapper {
      border: none;
      box-shadow: none;
      width: 550px;
      height: 270px;
  }

  .requirement-wrapper h4 {
      font-size: 20px;
      margin-top: 5px;
      margin-bottom: 20px;
  }

  .requirement-wrap p {
      font-size: 18px;
  }

  .twofa-security-wrap {
      width: 550px;
  }

  .twofa-guide-button button{
      width: 550px;
      height: 60px;
  }

  .twofa-security-wrap p {
      font-size: 16px;
      text-align: left;
  }

  .twofa-header h3 {
      font-size: 30px;
      margin: 0px;
  }

  .twofa-header {
      text-align: center;
      padding: 20px;
  }

  img.kyc-status-review {
      width: 220px;
      height: auto;
  }

  p.twofa-status.status-text {
      font-size: 34px;
  }

  p.review-time {
      font-size: 22px;
  }

  .twofa-footer.kyc-review-footer{
      bottom: 30px !important;
  }

  .twofa-security-wrapper{
      padding-bottom: 20px;
  }

  .twofa-guide-button {
      margin-top: 20px;
  }
}


@media (min-width: 1024px) and (max-width: 1599px){
  p.kyc-text {
      font-size: 22px;
      width: 55%;
      margin-bottom: 30px;
      margin-top: 20px;
  }

  .requirement-wrap {
      margin-bottom: 22px;
  }


  .kyc-requirement-wrapper {
      border: none;
      box-shadow: none;
      width: 550px;
      height: 270px;
  }

  .requirement-wrapper h4 {
      font-size: 20px;
      margin-top: 5px;
      margin-bottom: 20px;
  }

  .requirement-wrap p {
      font-size: 18px;
  }

  .twofa-security-wrap {
      width: 550px;
  }

  .twofa-guide-button button{
      width: 550px;
      height: 60px;
  }

  .twofa-security-wrap p {
    font-size: 14px;
    text-align: left;
  }

  .twofa-header h3 {
      font-size: 30px;
      margin: 0px;
  }

  .twofa-header {
      text-align: center;
      padding: 20px;
  }

  img.kyc-status-review {
      width: 220px;
      height: auto;
  }

  p.twofa-status.status-text {
      font-size: 34px;
  }

  p.review-time {
      font-size: 22px;
  }

  .twofa-footer.kyc-review-footer{
      bottom: 30px !important;
  }

  .twofa-security-wrapper{
    padding-bottom: 12px;
  }

  .twofa-guide-button {
      margin-top: 20px;
  }
}

@media(min-width: 1600px){
  .twofa-footer.kyc-review-footer{
      bottom: 50px !important;
  }

  .twofa-header.kyc-verification-header {  
      height: 105px;
  }

}

.accented {
  accent-color: #00A19B;
}


.for-space-disaper-button{
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/Dashboard/TwoFa/Twofa1.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;;GAEG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;EACtB,YAAY;EACZ,YAAY;IACV,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ,WAAW;EACX,YAAY;IACV,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;;AAGA;IACI,uBAAuB;IACvB,4BAA4B;EAC9B,8BAA8B;AAChC;;AAEA;IACI,YAAY;AAChB;;;AAGA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;AAChB;;EAEE;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;AAEF;EACE,WAAW;EACX,YAAY;AACd;;EAEE;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;AACA;;;AAGA;EACE;;KAEG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,SAAS;IACT,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;IACpB,gCAAgC;IAChC,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;;KAGG;;EAEH;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;AACpB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;;KAGG;;EAEH;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;;EAGA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;EAEE;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;AAEF;;;;AAIA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE;;;KAGG;;EAEH;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;IACf,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,cAAc;AAClB;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;AACjB;;;EAGE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,wBAAwB;IACxB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;;;EAIA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,gBAAgB;EAClB;;;;EAIA;IACE,kBAAkB;;EAEpB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;;AAGF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;;;EAGA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,WAAW;EACb;;;EAGA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;AAEA;EACE,oBAAoB;AACtB;;;AAGA;EACE,8BAA8B;EAC9B,YAAY;EACZ,eAAe;AACjB;;;AAGA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,yDAA2D;EAC3D,qCAAqC;EACrC,uCAAuC;EACvC,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;;;GASG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE;;kBAEgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,2CAA2C;IAC3C,YAAY;EACd;;EAEA;IACE,2CAA2C;IAC3C,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;KAEG;;EAEH;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB;8BAC0B;IAC1B,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;;;KAGG;;EAEH;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;AACtB;AACA;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;;;AAIA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE;IACE,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,iBAAiB;EACnB;;EAEA;IACE,QAAQ;IACR,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;GAChB,UAAU;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,6BAA6B;IAC7B,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,gBAAgB;EAClB;;;EAGA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;IACd,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE;IACE,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;EAChB;AACF;;AAEA;EACE;;;IAGE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,UAAU;IACV,2BAA2B;IAC3B,cAAc;IACd,SAAS;IACT,gBAAgB;EAClB;;AAEF;;;;AAIA,gEAAgE;AAChE;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;;AAGA;EACE,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;;AAGA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;AAC3B;;;AAGA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA;EACE;MACI,UAAU;MACV,aAAa;EACjB;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,eAAe;MACf,WAAW;MACX,mBAAmB;MACnB,gBAAgB;EACpB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,WAAW;EACf;;EAEA;MACI,eAAe;EACnB;;;EAGA;MACI,eAAe;MACf,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,gBAAgB;MAChB,mBAAmB;EACvB;;EAEA;MACI,mBAAmB;EACvB;;;EAGA;MACI,kBAAkB;MAClB,gBAAgB;EACpB;;EAEA;MACI,YAAY;MACZ,YAAY;EAChB;;EAEA;MACI,WAAW;MACX,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,gBAAgB;EACpB;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;;EAEA;MACI,WAAW;MACX,YAAY;EAChB;;;EAGA;MACI,QAAQ;MACR,uBAAuB;EAC3B;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,oBAAoB;EACxB;AACF;;AAEA;EACE;MACI,eAAe;MACf,UAAU;MACV,mBAAmB;MACnB,gBAAgB;EACpB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,YAAY;MACZ,gBAAgB;MAChB,YAAY;MACZ,aAAa;EACjB;;EAEA;MACI,eAAe;MACf,eAAe;MACf,mBAAmB;EACvB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,YAAY;EAChB;;EAEA;MACI,YAAY;MACZ,YAAY;EAChB;;EAEA;MACI,eAAe;MACf,gBAAgB;EACpB;;EAEA;MACI,eAAe;MACf,WAAW;EACf;;EAEA;MACI,kBAAkB;MAClB,aAAa;EACjB;;EAEA;MACI,YAAY;MACZ,YAAY;EAChB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,uBAAuB;EAC3B;;EAEA;MACI,oBAAoB;EACxB;;EAEA;MACI,gBAAgB;EACpB;AACF;;;AAGA;EACE;MACI,eAAe;MACf,UAAU;MACV,mBAAmB;MACnB,gBAAgB;EACpB;;EAEA;MACI,mBAAmB;EACvB;;;EAGA;MACI,YAAY;MACZ,gBAAgB;MAChB,YAAY;MACZ,aAAa;EACjB;;EAEA;MACI,eAAe;MACf,eAAe;MACf,mBAAmB;EACvB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,YAAY;EAChB;;EAEA;MACI,YAAY;MACZ,YAAY;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;MACI,eAAe;MACf,WAAW;EACf;;EAEA;MACI,kBAAkB;MAClB,aAAa;EACjB;;EAEA;MACI,YAAY;MACZ,YAAY;EAChB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,eAAe;EACnB;;EAEA;MACI,uBAAuB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;MACI,gBAAgB;EACpB;AACF;;AAEA;EACE;MACI,uBAAuB;EAC3B;;EAEA;MACI,aAAa;EACjB;;AAEF;;AAEA;EACE,qBAAqB;AACvB;;;AAGA;EACE,UAAU;AACZ","sourcesContent":["/* .twofa-guide-wrapper {\n  padding-top: 80px;\n} */\n\n/* .navbar-space-wrapper{\n  padding-top: 80px;\n} */\n\n.twofa-mobile-header {\n  display: none;\n}\n\nh2.twofa-status-desabled{\n  color: #FF360D !important;\n}\n\n.authnticator-icon-wrap{\n  margin-bottom: 60px;\n}\n\np.twofa-status.status-text {\n  font-size: 30px;\n  color: #383838;\n}\n\n.twofa-guide-wrapper {\n  /* height: 100vh; */\n}\n\n.twofa-header {\n  text-align: center;\n  padding-top: 20px;\n  /* border-bottom: 1px solid #858585; */\n}\n\n.twofa-header h3 {\n  font-size: 28px;\n  color: #383838;\n}\n\n.twofa-enable-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 25px;\n  padding-bottom: 200px;\n}\n\n.twofa-enable-wrapper img {\n  width: 120px;\n  height: 120px;\n}\n\n.twofa-enable-wrapper h4 {\n  /* color: #383838; */\n  /* font-size: 20px; */\n}\n\n.twofa-enable-wrapper p {\n  font-size: 15px;\n  color: #717171;\n}\n\n.download-authenticator-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n}\n\n.download-authenticator-wrap .playstore img {\n  width: 80px;\n  height: auto;\n}\n\n.twofa-security-wrap img {\n  width: 30px;\n  height: 30px;\n}\n\n.twofa-security-wrap {\n  display: flex;\n  /* align-items: center; */\n  justify-content: center;\n  gap: 10px;\n  width: 360px;\n  text-align: center;\n}\n\n.twofa-security-wrap img {\n  margin-top: 6px;\n}\n\n.twofa-security-wrapper {\n  /* padding-bottom: 20px; */\n  border-bottom: 1px solid #858585;\n}\n\n.twofa-security-wrap p {\n  margin: 0px;\n  color: #717171;\n  font-size: 13px;\n}\n\n.twofa-icons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  margin-top: 20px;\n}\n\n\n.twofa-icons {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n\n.icons {\n  width: 20px;\n  height: 20px;\n  background: #d2d2d2;\n  border-radius: 50%;\n}\n\n.active-icon {\n  background: #00A19B !important;\n}\n\n.twofa-guide-button img {\n  width: 50px;\n  height: 10px;\n}\n.twofa-guide-button button {\n  background: #00A19B;\n  border-radius: 10px;\n  opacity: 1;\n  border: none;\n  color: #FFFFFF;\n  padding: 10px 40px;\n  font-size: 15px;\n  font-weight: 600;\n  width: 651px;\n  height: 71px;\n}\n\n.ip-button {\n  margin-bottom: 15px;\n}\n\n.twofa-guide-button button:hover {\n  background-color: #fff;\n  color: #071224;\n  border: 2px solid #00A19B;\n}\n\n.qr-code-image img {\n  width: 200px;\n  height: 200px;\n  margin-top: 20px;\n  padding: 10px;\n  background: #fff;\n  border-radius: 8px;\n  border: 1px solid #cccccc30;\n}\n\n.qr-code-image {\n  padding: 40px 0px;\n}\n\n.twofa-backup-secret {\n  text-align: center;\n  /* max-width: 400px; */\n}\n\n.security-code-text {\n  text-align: center;\n}\n\n.security-code-text h3 {\n  font-size: 20px;\n  color: #383838;\n  padding: 40px 0px;\n}\n\n.security-code-text input {\n  height: 40px;\n  width: 250px;\n  border-radius: 8px;\n  border: 1px solid #707070;\n  outline: none;\n  font-size: 13px;\n  padding: 10px;\n  margin-bottom: 40px;\n  color: #717171;\n}\n\n.input {\n  position: relative;\n}\n\n.security-code-text img {\n  width: 17px;\n  height: 18px;\n  position: absolute;\n  right: 10px;\n  top: 10px;\n}\n\n.twofa-guide-button {\n  text-align: center;\n  margin-top: 5px;\n  margin-bottom: 12px;\n}\n\n.twofa-footer {\n  position: fixed;\n  bottom: 30px;\n  background: #fff !important;\n}\n\n.twofa-status-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.twofa-status-wrapper img {\n  width: 100px;\n  height: 100px;\n}\n\n.twofa-status-wrapper p {\n  font-size: 22px;\n  color: #383838;\n  /* margin: 0px; */\n  margin-top: 15px !important;\n  margin-bottom: 0px;\n}\n\n.twofa-status-wrapper h2 {\n  font-size: 32px;\n  color: #00A19B;\n  font-weight: 500;\n}\n\nh2.disable-request {\n  color: #FF360D;\n}\n\n.disable-btn {\n  padding-bottom: 50px;\n}\n\n.disable-btn button {\n  background: var(--buttonColor);\n  border-radius: 5px;\n  opacity: 1;\n  border: none;\n  color: #383838;\n  padding: 7px 26px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.confirm-button-wrap button {\n  background: #00A19B;\n  border-radius: 10px;\n  opacity: 1;\n  border: none;\n  color: #FFFFFF;\n  padding: 8px 40px;\n  font-size: 15px;\n  font-weight: 600;\n  height: 65px;\n  width: 100%;\n}\n\n.confirm-button-wrap button:hover {\n  background-color: #fff;\n  border: 2px solid #00A19B;\n  color: #071224;\n}\n\n.confirm-button-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding-bottom: 10px;\n}\n\nbutton.cancel-button {\n  background: #9b9b9b;\n  border-radius: 10px;\n  opacity: 1;\n  border: none;\n  color: #383838;\n  padding: 8px 40px;\n  margin-top: 20px;\n  font-weight: 600;\n}\n\n.resend-email-btn button {\n  background: #00A19B;\n  border-radius: 10px;\n  opacity: 1;\n  border: none;\n  color: #fff;\n  padding: 8px 40px;\n  height: 49px;\n  margin-top: 20px;\n  font-weight: 500;\n}\n\n\nbutton.cancel-button:hover {\n  background: #FFFFFF;\n  border: 2px solid #CBCBCB;\n}\n\n.receive-security-key {\n  position: relative;\n}\n\n.receive-security-key input {\n  width: 100%;\n  padding: 18px 10px;\n  width: 380px;\n  border: 1px solid #707070;\n  border-radius: 8px;\n  outline: none;\n  color: #717171;\n  font-size: 17px;\n  position: relative;\n}\n\n.input-box {\n  padding: 22px 30px;\n  width: 550px;\n  height: 70px;\n  background-color: #F8F8F8;\n  border: none;\n  border-radius: 10px\n}\n\n.input-box p {\n  font-size: 15px;\n  width: 265px;\n  overflow: hidden;\n  margin: 0px;\n}\n\n.copy-btn img {\n  width: 20px;\n  position: absolute;\n  top: -34px;\n  right: 17px;\n  border: 0;\n  cursor: pointer;\n}\n\n.receive-security-key input:focus {\n  display: none;\n}\n\n\n.twofa-guide-header-content {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.twofa-guide-header-content img{\n  width: 58px !important;\n}\n\n\n.twofa-guide-wrapper .container {\n  position: relative;\n  /* min-height: 95vh; */\n}\n\n\n.disable-twofa-input-wrap{\n  margin-top: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.disable-twofa-input-wrap input[type=checkbox]{\n    height: 0;\n    width: 0;\n    visibility: hidden;\n}\n\n.disable-twofa-input-wrap label {\n    cursor: pointer;\n    text-indent: -9999px;\n  width: 150px;\n  height: 72px;\n    background: #F8F8F8;\n    display: block;\n    border-radius: 100px;\n    position: relative;\n}\n\n.disable-twofa-input-wrap label:after {\n    content: '';\n    position: absolute;\n    top: 12px;\n    left: 10px;\n  width: 50px;\n  height: 50px;\n    background: #BFBFBF;\n    border-radius: 90px;\n    transition: 0.3s;\n}\n\n\n.disable-twofa-input-wrap input:checked + label:after {\n    left: calc(100% - 10px);\n    transform: translateX(-100%);\n  background: #00A19B !important;\n}\n\n.disable-twofa-input-wrap label:active:after {\n    width: 130px;\n}\n\n\n.disable-twofa-input-wrap p{\n  font-size: 24px;\n  color: #717171;\n}\n\n.twofa-security-wrap input {\n  width: 50px;\n  height: 36px;\n  cursor: pointer;\n}\n\n\n.admin-sidebar-space{\n  margin-left: 140px;\n}\n\n@media (max-width: 1024px) {\n  .twofa-icons{\n    display: none;\n  }\n\n  .twofa-enable-wrapper img {\n    width: 130px;\n    height: auto;\n}\n\n  .copy-btn img {\n    width: 20px;\n    height: 20px;\n    top: 25px;\n  }\n\n.twofa-security-wrap img {\n  width: 23px;\n  height: 23px;\n}\n\n  .twofa-enable-wrapper h4 {\n    color: #383838;\n    font-size: 20px;\n    margin-top: 50px;\n    margin-bottom: 0px;\n  }\n\n  h4.get-appstore-playstore {\n    font-size: 18px;\n    font-weight: 400;\n  }\n\n  .twofa-enable-wrapper p {\n    font-size: 24px;\n    font-weight: 500;\n  }\n\n  .twofa-status-wrapper h2 {\n    font-size: 36px;\n  }\n\n  .disable-twofa-input-wrap p {\n    font-size: 18px;\n  }\n  \n  h2.disable-request {\n    margin-top: 60px;\n  }\n\n  .disable-twofa-input-wrap label {\n    width: 140px;\n    height: 62px;\n  }\n\n  .disable-twofa-input-wrap label:after {\n    width: 35px;\n    height: 35px;\n  }\n\n  .security-code-text{\n    text-align: left;\n    margin-top: 100px;\n  }\n\n  .security-code-text h3 {\n    font-size: 20px;\n    color: #383838;\n    padding: 0px 0px;\n}\n\n.pin-code-twofa input {\n  width: 60px;\n  height: 60px;\n  font-size: 36px;\n  margin-right: 2px;\n}\n}\n\n\n@media (max-width: 767px) {\n  /* .twofa-header h3 {\n    display: none;\n  } */\n\n  p.twofa-status.status-text {\n    font-size: 25px;\n  }\n\n  .twofa-desktop {\n    display: none;\n  }\n\n  .receive-security-key {\n    width: 98%;\n  }\n\n  .receive-security-key input {\n    padding: 18px 10px;\n    width: 100%;\n    border: 1px solid #707070;\n    border-radius: 8px;\n    outline: none;\n    position: relative;\n  }\n\n  .input-box {\n    padding: 18px 30px;\n    width: 100%;\n    border-radius: 10px;\n    outline: none;\n    position: relative;\n  }\n\n  .input-box p {\n    font-size: 18px;\n    width: 81%;\n    text-align: left !important;\n    overflow: hidden;\n    margin-top: 3px;\n  }\n\n  .copy-btn img {\n    width: 20px;\n    position: absolute;\n    top: -28px;\n    right: 17px;\n    border: 0;\n    cursor: pointer;\n    z-index: 99;\n  }\n\n  .twofa-mobile-header {\n    font-size: 24px !important;\n    color: #383838;\n    display: block !important;\n  }\n\n  .twofa-security-wrapper {\n    padding-bottom: 20px;\n    border-bottom: 1px solid #858585;\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  .twofa-enable-wrapper {\n    gap: 12px;\n    margin-top: 20px;\n  }\n\n  .download-authenticator-wrap .playstore img {\n    width: 65px;\n    height: auto;\n  }\n\n  /* .twofa-enable-wrapper img {\n    width: 100px;\n    height: 100px;\n  } */\n\n  img.scanner-img {\n    width: 170px;\n    height: 170px;\n    margin-top: 10px;\n  }\n\n  .twofa-guide-button img {\n    width: 50px;\n    height: 10px;\n  }\n\n  .twofa-security-wrap img {\n    width: 30px;\n    height: 30px;\n  }\n\n  .twofa-security-wrap {\n    width: 100%;\n  }\n\n  .twofa-enable-wrapper p {\n    margin: 0px;\n    font-size: 18px;\n    width: 90%;\n    text-align: center;\n  }\n\n  p.twofa-status {\n    font-size: 22px;\n    font-weight: 500;\n}\n\n  .twofa-status-wrapper h2 {\n    font-size: 32px;\n  }\n\n  .disable-twofa-input-wrap p {\n    font-size: 14px;\n  }\n\n  .twofa-enable-wrapper {\n    margin-top: 50px !important;\n  }\n\n  /* .twofa-enable-wrapper img {\n    width: 110px;\n    height: 144px;\n  } */\n\n  .copy-btn img {\n    width: 20px;\n    height: 20px;\n    top: 25px;\n  }\n\n\n  .authnticator-icon-wrap {\n    margin-top: 20px;\n    margin-bottom: 0px;\n  }\n\n  .twofa-enable-wrapper h4 {\n    color: #383838;\n    font-size: 20px;\n    margin-top: 40px;\n    margin-bottom: 0px;\n  }\n\n  h4.get-appstore-playstore {\n    font-size: 18px;\n    font-weight: 400;\n  }\n\n  .twofa-header h3 {\n    font-size: 25px;\n    color: #383838;\n  }\n\n  .security-code-text img {\n    width: 17px;\n    height: 18px;\n  }\n\n  h2.disable-request {\n    color: #ff360d;\n    font-size: 30px;\n    margin-top: 14px;\n  }\n\n  .twofa-footer {\n    position: unset;\n    margin-top: 40px !important;\n    background: #fff !important;\n    padding-bottom: 5px;\n  }\n\n  .twofa-guide-header-content img {\n    display: none;\n  }\n\n  .twofa-icons {\n    display: none;\n  }\n\n  p.download-2fa {\n    font-size: 18px;\n    color: #383838;\n    margin-top: 12px;\n}\n\n  p.twofa-auth-code-text{\n    font-size: 20px;\n    color: #383838;\n    margin-top: 20px;\n  }\n\n  .qr-code-image {\n    padding: 30px 0px;\n  }\n\n  .security-code-text{\n    text-align: left;\n    margin-top: 100px;\n  }\n\n  .security-code-text h3{\n    padding: 0px;\n  }\n\n\n  .pin-code-twofa input{\n    width: 50px !important;\n    height: 50px !important;\n  }\n\n  .twofa-security-wrap input {\n    width: 22px;\n    height: 30px;\n  }\n\n}\n\n\n\n@media (max-width: 380px) {\n  .pin-code-twofa input{\n    width: 45px !important;\n    height: 48px !important;\n  }\n}\n\n@media (min-width: 1800px) and (max-width: 2100px) {\n  /* .twofa-footer {\n    position: absolute;\n    bottom: 150px;\n  } */\n\n  .twofa-footer {\n    position: fixed;\n    bottom: 10px !important;\n  }\n}\n\n@media (min-width: 2100px) {\n  .twofa-footer {\n    position: fixed;\n    bottom: 10px !important;\n  }\n}\n\n@media (min-width: 1600px) {\n  .download-authenticator-wrap {\n    padding: 10px 0px 20px 0px;\n  }\n\n  .disable-btn {\n    padding-bottom: 10px;\n  }\n\n  .twofa-security-wrap {\n    width: 650px;\n    text-align: left;\n    padding-bottom: 24px;\n  }\n\n  .qr-code-image {\n    padding: 60px 0px;\n  }\n\n  .twofa-security-wrap p {\n    font-size: 18px;\n  }\n\n  .twofa-enable-wrapper p {\n    font-size: 18px;\n    color: #717171;\n  }\n\n  p.twofa-auth-code-text {\n    font-size: 28px;\n    color: #383838;\n}\n\n  .twofa-header h3 {\n    font-size: 38px;\n  }\n\n  .twofa-guide-button button {\n    margin-top: 20px;\n  }\n\n  .twofa-guide-button img {\n    width: 80px;\n    height: 12px;\n  }\n\n  .download-authenticator-wrap .playstore img {\n    width: 86px;\n    height: 86px;\n  }\n\n  .twofa-footer {\n    position: fixed;\n    bottom: 10px !important;\n  }\n\n  .twofa-enable-wrapper img {\n    width: 138px;\n    height: 170px;\n}\n\n\n  .authnticator-icon-wrap img {\n    width: 300px;\n    height: 300px;\n  }\n\n  .twofa-security-wrap img {\n    width: 30px;\n    height: 30px;\n  }\n\n  .twofa-guide-button img {\n    width: 80px;\n    height: 12px;\n  }\n\n  .twofa-enable-wrapper {\n    gap: 10px;\n  }\n\n  .security-code-text img {\n    width: 17px;\n    height: 18px;\n  }\n\n  img.scanner-img {\n    width: 300px !important;\n    height: 300px !important;\n    margin-top: 0px;\n  }\n\n  .security-code-text h3 {\n    font-size: 28px;\n    text-align: left;\n    padding: 10px 0px;\n  }\n\n\n\n  .input-box {\n    /* height: 55px; */\n    padding: 22px 30px;\n    width: 651px;\n    height: 70px;\n    background-color: #F8F8F8;\n    border: none;\n  }\n\n  .input-box p {\n    font-size: 20px;\n    width: 275px;\n    overflow: hidden;\n    /* margin-top: 13px; */\n  }\n\n  .security-code-text {\n    text-align: center;\n    margin: 55px 0px;\n  }\n\n  .security-code-text img {\n    top: 16px;\n  }\n\n  .auth-input {\n    margin: 180px 0px;\n  }\n\n  /* .twofa-status-wrapper {\n    margin-top: 100px;\n  } */\n\n  .twofa-status-wrapper h2 {\n    font-size: 50px;\n    padding-top: 0px;\n  }\n\n\n\n  h2.disable-request {\n    padding-top: 100px;\n\n  }\n\n  p.twofa-status {\n    font-size: 38px;\n    color: #383838;\n    font-weight: 500;\n  }\n\n  .copy-btn img {\n    width: 25px;\n    height: 25px;\n    position: absolute;\n    top: 20px;\n    right: 30px;\n    border: 0;\n    cursor: pointer;\n  }\n\n  p.download-2fa {\n    font-size: 22px;\n    color: #383838;\n  }\n\n  .twofa-status-wrapper {\n    margin-top: 80px;\n  }\n\n\n  .dashboard-twofa-enable-wrapper{\n    margin-top: 0px;\n  }\n\n  .dashboard-twofa-enable-wrapper .twofa-status-wrapper{\n    margin-top: 36px;\n  }\n\n  .reivew-wrap {\n    margin-top: 20px;\n  }\n\n  .reivew-wrap img {\n    width: 30px;\n    height: auto;\n  }\n\n\n}\n\n.reivew-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n}\n\n.reivew-wrap p {\n  margin: 0px !important;\n}\n\n.reivew-wrap img {\n  width: 30px;\n  height: auto;\n}\n\np.review-time {\n  font-size: 17px;\n  color: #717171;\n}\n\np.user-alert-text {\n  font-size: 16px;\n  text-align: center;\n  color: #717171;\n  margin-bottom: 30px;\n}\n\n\np.download-2fa {\n  color: #383838;\n}\n\n.twofa-auth-code-text {\n  color: #383838;\n}\n\n@media (min-width: 1024px) and (max-width: 1599px) {\n  .enable-pin-code-twofa .pin-code-twofa input {\n    width: 60px !important;\n    height: 60px !important;\n    font-size: 20px !important;\n    margin-right: 2px;\n  }\n\n  .twofa-enable-wrapper h4 {\n    font-size: 24px;\n    margin-top: 20px;\n    margin-bottom: 0px;\n  }\n\n  .twofa-guide-header-content img {\n    width: 42px !important;\n  }\n\n  .authnticator-icon-wrap {\n    margin-bottom: -20px;\n    margin-top: -30px;\n  }\n\n  .download-authenticator-wrap .playstore img {\n    width: 70px;\n    height: auto;\n  }\n\n  h4.get-appstore-playstore {\n    font-size: 18px;\n    font-weight: 400;\n  }\n\n  .twofa-enable-wrapper img {\n    width: 80px;\n    height: 100px;\n  }\n\n  .copy-btn img {\n    width: 24px;\n    height: 24px;\n    top: 18px;\n  }\n\n\n  .qr-code-image img {\n    width: 220px;\n    height: 220px;\n    margin-top: 10px;\n  }\n\n  .twofa-security-wrap img {\n    width: 24px;\n    height: 24px;\n  }\n\n  .reivew-wrap img {\n    width: 30px;\n    height: auto;\n  }\n\n\n  .twofa-enable-wrapper p {\n    font-size: 22px;\n    font-weight: 500;\n    margin-top: 2px !important;\n  }\n\n  .input-box p {\n    font-size: 20px;\n    margin-top: -2px !important;\n  }\n\n  .copy-btn p {\n    font-size: 20px;\n  }\n\n  .receive-security-key p {\n    font-size: 18px;\n  }\n\n  .twofa-enable-wrapper .twofa-status-wrapper h2 {\n    font-size: 32px;\n  }\n\n  h2.disable-request {\n    margin-top: 60px;\n  }\n\n  .disable-twofa-input-wrap p {\n    font-size: 20px;\n  }\n\n  .qr-code-image {\n    padding-top: 2px;\n    padding-bottom: 20px;\n  }\n\n  .input-box {\n    padding: 18px 30px;\n    width: 550px;\n    height: 65px;\n    background-color: #F8F8F8;\n    border: none;\n  }\n\n  p.download-2fa {\n    font-size: 22px;\n    color: #383838;\n    font-weight: 400;\n    margin: 0px;\n  }\n\n\n  p.twofa-auth-code-text {\n    font-size: 22px;\n    color: #383838;\n    font-weight: 400;\n}\n\n\n.security-code-text {\n  text-align: left;\n  margin-top: 70px;\n}\n\n.security-code-text h3 {\n  font-size: 24px;\n  padding: 10px 0px;\n}\n\n.disable-twofa-input-wrap label {\n  width: 120px;\n  height: 48px;\n}\n\n.disable-twofa-input-wrap p {\n  font-size: 16px !important;\n  color: #717171;\n}\n\n.disable-twofa-input-wrap label:after {\n  width: 28px;\n  height: 28px;\n}\n\n.disable-twofa-input-wrap label:after {\n  top: 10px;\n}\n\n.twofa-enable-wrapper .twofa-status-wrapper {\n  margin: 30px;\n}\n\n.twofa-security-wrap input {\n  width: 50px;\n  height: 40px;\n}\n\n}\n\n.confirm-button-wrap {\n  padding-bottom: 10px;\n}\n\n\nbutton.disabled-button {\n  background: #E1E1E1 !important;\n  color: #ffff;\n  cursor: no-drop;\n}\n\n\nbutton.disabled-button:hover {\n  background: #E1E1E1 !important;\n  border: none !important;\n  color: #ffff !important;\n  cursor: no-drop;\n}\n\n/************** ChangeSecurity css import here *********/\n.change-pin-wrapper {\n  padding-top: 80px;\n  background-image: url(\"../../assets/images/profile-bg.png\");\n  background-size: 100% 100% !important;\n  background-repeat: no-repeat !important;\n  background-attachment: fixed;\n  min-height: 100vh;\n}\n\n.change-principle-active {\n  border-bottom: 4px solid var(--buttonColor);\n  width: 85px;\n  text-align: center;\n}\n\n.change-principle-active:hover {\n  border-bottom: 4px solid var(--buttonHover);\n  width: 85px;\n  text-align: center;\n}\n\n.change-pin-wraper {\n  /* padding-bottom: 220px; */\n  /* overflow: scroll; */\n}\n\n.login-change-form .field {\n  position: relative;\n  width: 100%;\n  background: #F8F8F8;\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n\n.twofa-header {\n  text-align: center;\n  padding-top: 20px;\n  border-bottom: 1px solid #ccc;\n  padding-bottom: 10px;\n}\n\n.twofa-header h3 {\n  font-size: 28px;\n  color: #383838;\n}\n\n.change-pin-wrap {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 50px;\n  padding-top: 20px;\n}\n\n.change-login-active {\n  border-bottom: 4px solid var(--buttonColor);\n  width: 170px;\n  text-align: center;\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    transform: translateX(-50px);\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.change-login-active:hover {\n  border-bottom: 4px solid var(--buttonHover);\n  width: 170px;\n  text-align: center;\n}\n\n.must-contain-wrapper {\n  /* text-align: center; */\n  background: #F8FBFE;\n  width: 400px;\n  margin: 0 auto;\n  margin-top: 20px;\n  border-radius: 20px;\n  border-radius: 19px;\n  min-height: 150px;\n}\n\n.list-icon {\n  width: 10px;\n  height: 10px;\n  border-radius: 100%;\n  background: #00A19B;\n}\n\n.list {\n  display: flex;\n  /* justify-content: center; */\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.list p {\n  font-size: 16px;\n  margin: 0px;\n  color: #717171;\n}\n\n.kyc-requirement-wrapper {\n  /* text-align: center; */\n  width: 400px;\n  margin: 0 auto;\n  margin-top: 20px;\n  border-radius: 20px;\n  box-shadow: 0px 3px 6px #0000001a;\n  border: 2px solid #4d9798;\n  border-radius: 19px;\n  min-height: 150px;\n}\n\n.requirement-wrapper {\n  padding: 20px;\n  width: 100%;\n  margin-left: 30px;\n}\n\n.requirement-wrap p {\n  font-size: 22px;\n  color: #717171;\n  margin: 0px;\n}\n\n.requirement-wrap img {\n  width: 25px;\n}\n\nimg.selfie-img {\n  width: 20px !important;\n  margin-right: 10px;\n}\n\n.requirement-wrap {\n  display: flex;\n  /* justify-content: center; */\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 28px;\n}\n\np.kyc-text {\n  font-size: 18px;\n  width: 500px;\n  color: #383838;\n  margin: 0 auto;\n  text-align: center;\n  margin-top: 25px;\n  margin-bottom: 40px;\n}\n\n.login-change-form {\n  width: 400px;\n  margin: 0 auto;\n  margin-top: 30px;\n}\n\n/* .login-change-form input {\n  width: 100%;\n  margin-bottom: 15px;\n  border: 1px solid #707070;\n  border-radius: 6px;\n  outline: none;\n  font-size: 14px;\n  color: #707070;\n  z-index: unset;\n} */\n\n.login-change-form input {\n  width: 100%;\n  border: none;\n  background: #F8F8F8;\n  outline: none;\n  font-size: 14px;\n  color: #707070;\n  z-index: 22;\n  position: relative;\n  background: none;\n  outline: none;\n  box-shadow: none;\n}\n\n.kyc-requirement-info-wrapper h3 {\n  text-align: center;\n  margin-top: 80px;\n  color: #383838;\n  font-size: 24px;\n}\n\n.change-login h2 {\n  font-size: 20px;\n  color: #858585;\n  cursor: pointer;\n}\n\nh2.active-login {\n  font-size: 20px;\n  color: #383838 !important;\n  cursor: pointer;\n}\n\n.list-wrapper {\n  /* width: 200px;\n  margin: 0 auto;\n  padding: 15px; */\n  padding: 28px 50px;\n}\n\n.must-contain-wrapper h3 {\n  font-size: 18px;\n  color: #383838;\n  padding-bottom: 16px;\n}\n\n@media (max-width: 767px) {\n  p.kyc-text {\n    font-size: 16px;\n    width: 100%;\n  }\n\n  .login-confirm-pin {\n    margin-top: 100px;\n  }\n\n  .secured-pin-wrap {\n    margin-bottom: 100px !important;\n  }\n\n  .change-login-active {\n    border-bottom: 3px solid var(--buttonColor);\n    width: 140px;\n  }\n\n  .change-login-active:hover {\n    border-bottom: 3px solid var(--buttonHover);\n    width: 140px;\n    text-align: center;\n  }\n\n  .kyc-requirement-wrapper {\n    width: 100%;\n    height: 250px;\n  }\n\n  .kyc-requirement-info-wrapper h3 {\n    text-align: center;\n    margin-top: 50px;\n  }\n\n\n  .must-contain-wrapper {\n    width: 100%;\n  }\n\n  .login-change-form {\n    width: 100%;\n  }\n\n  h2.active-login {\n    font-size: 24px;\n    color: #383838 !important;\n  }\n\n  .change-login h2 {\n    /* font-size: 24px; */\n    font-size: 17px;\n    color: #858585;\n  }\n\n  .list p {\n    font-size: 18px;\n    margin: 0px;\n  }\n\n  .list {\n    gap: 15px;\n    margin-bottom: 10px;\n  }\n\n  .list-wrapper {\n    padding: 30px;\n  }\n\n  .list-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  .must-contain-wrapper {\n    margin-top: 30px;\n  }\n\n  .twofa-header {\n    padding-top: 20px;\n    padding-bottom: 10px;\n    height: 78px;\n  }\n\n  .twofa-header h3 {\n    font-size: 30px;\n    color: #383838;\n  }\n\n  .login-change-form.password-change {\n    margin-top: 40px;\n  }\n\n  /* .login-change-form input {\n    margin-bottom: 15px;\n  } */\n\n  .twofa-security-wrap p {\n    font-size: 14px;\n    text-align: left;\n  }\n\n  .pin-code input {\n    border: 1px solid #707070;\n    text-align: center;\n    /* width: 60px !important;\n    height: 60px !important; */\n    margin-right: 15px !important;\n    font-size: 36px;\n    background-color: #fff;\n  }\n\n  .must-contain-wrapper h3 {\n    font-size: 20px;\n  }\n\n  .login-change-form input {\n    width: 100%;\n    height: 65px;\n  }\n\n  .login-change-form .field label::before {\n    top: 20px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .must-contain-wrapper{\n    width: 550px;\n    min-height: 100px !important;\n    margin-top: 10px !important;\n    background: unset;\n  }\n\n  .list {\n    gap: 8px;\n    margin-bottom: 0px;\n  }\n\n  .list p {\n    font-size: 16px;\n  }\n\n  .must-contain-wrapper h3 {\n    font-size: 22px;\n    margin-top: 15px;\n    padding-bottom: 8px;\n  }\n\n  .login-change-form {\n    width: 550px;\n    margin-top: 10px;\n  }\n\n  .change-pin-list-wrapper {\n    width: 200px;\n  }\n\n\n  .password-change {\n    margin-top: 60px;\n  }\n\n  .pin-code input {\n    width: 70px;\n    height: 60px;\n    margin-right: 10px;\n  }\n\n  h2.active-login {\n    font-size: 20px;\n    color: #383838 !important;\n  }\n\n  .change-login h2 {\n    font-size: 16px;\n    color: #858585;\n  }\n\n  .list p {\n    font-size: 13px;\n    margin: 0px;\n  }\n\n  .list p {\n    font-size: 15px;\n    margin: 0px;\n  }\n\n  .list {\n    gap: 15px;\n    margin-bottom: 10px;\n  }\n\n  .list-wrapper {\n    padding: 10px;\n  }\n\n  .must-contain-wrapper {\n    margin-top: 15px;\n  }\n\n  .twofa-header {\n    padding-top: 8px;\n  }\n\n  .twofa-header h3 {\n    font-size: 22px;\n    color: #383838;\n  }\n\n  .login-change-form {\n    margin-top: 20px;\n    padding-bottom: 180px;\n  }\n\n  /* .login-change-form input {\n    margin-bottom: 25px;\n    padding: 2px 10px;\n  } */\n\n  .twofa-security-wrap p {\n    font-size: 12px;\n  }\n\n  .list-wrap{\n    margin-top: 0px;\n    gap: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .list-wrap-left {\n    display: flex;\n    gap: 17px;\n  }\n\n  .list-wrap-right {\n    display: flex;\n    gap: 17px;\n  }\n\n  .login-change-form input {\n    width: 100%;\n    height: 65px;\n    font-size: 18px;\n    padding-left: 30px;\n  }\n\n  .list-wrapper {\n    padding: 0px;\n    text-align: center;\n}\n}\n\n.login-change-form h2 {\n  /* font-family: helvetica; */\n  text-align: center;\n  font-size: 20px;\n  color: #383838;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.pin-code {\n  padding: 0;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n}\n\n.pin-code-twofa {\n  padding: 0;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.pin-code-twofa input {\n  border: none;\n  border-radius: 8px;\n  outline: none;\n  text-align: center;\n  width: 80px;\n  height: 80px;\n  font-size: 36px;\n  background-color: #F8F8F8;\n  margin-right: 5px;\n  color: #383838;\n  line-height: normal;\n}\n\n.pin-code input {\n  border: 1px solid #707070;\n  text-align: center;\n  width: 48px;\n  height: 48px;\n  font-size: 36px;\n  background-color: #fff;\n  margin-right: 5px;\n}\n\n\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.show {\n  display: block !important;\n}\n\n.hide {\n  display: none;\n}\n\n.table-icons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  /* transition: 0.5s; */\n}\n\n\n@media (min-width: 1025px) and (max-width: 1599px) {\n  .must-contain-wrapper{\n    width: 550px;\n    min-height: 100px !important;\n    margin-top: 10px !important;\n    background: unset;\n  }\n\n  .list {\n    gap: 8px;\n    margin-bottom: 0px;\n  }\n\n  .list p {\n    font-size: 16px;\n  }\n\n  .must-contain-wrapper h3 {\n    font-size: 22px;\n    margin-top: 15px;\n    padding-bottom: 8px;\n  }\n\n  .login-change-form {\n    width: 550px;\n    margin-top: 10px;\n  }\n\n  .field label::before {\n    font-size: 16px;\n   left: 30px;\n  }\n\n  .pin-code input {\n    width: 70px;\n    height: 60px;\n    margin-right: 10px;\n  }\n\n\n  .kyc-requirement-info-wrapper h3 {\n    text-align: center;\n    margin-top: 10px;\n  }\n\n  p.kyc-text {\n    margin-top: 20px;\n    margin-bottom: 20px;\n  }\n\n  .requirement-wrap {\n    margin-bottom: 20px;\n  }\n\n  .list-wrap{\n    margin-top: 0px;\n    gap: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .list-wrap-left {\n    display: flex;\n    gap: 17px;\n  }\n\n  .list-wrap-right {\n    display: flex;\n    gap: 17px;\n  }\n\n  .login-change-form input {\n    width: 100%;\n    height: 65px;\n    font-size: 18px;\n    padding-left: 30px;\n  }\n\n  .list-wrapper {\n    padding: 0px;\n    text-align: center;\n}\n\n.twofa-enable-wrapper {\n  margin-top: 0px;\n  padding-bottom: 120px;\n  gap: 2px;\n}\n\n.twofa-footer {\n  position: fixed;\n  bottom: 10px;\n}\n  \n}\n\n@media (min-width: 1600px) {\n  .twofa-header h3 {\n    font-size: 45px;\n    color: #383838;\n  }\n\n  .twofa-header {\n    text-align: center;\n    padding-top: 29px;\n    border-bottom: 1px solid #ccc;\n    padding-bottom: 10px;\n  }\n\n  .change-login h2 {\n    font-size: 24px;\n  }\n\n  .change-pin-wrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 50px;\n    padding-top: 25px;\n  }\n\n  .must-contain-wrapper h3 {\n    font-size: 24px;\n    color: #383838;\n    font-family: 'Montserrat';\n    font-weight: 500;\n  }\n\n\n  .list {\n    gap: 20px;\n  }\n\n  .list p {\n    color: #717171;\n    font-size: 20px;\n    margin: 0px;\n  }\n\n  .list-icon {\n    width: 14px;\n    height: 14px;\n  }\n\n  .login-change-form {\n    margin-top: 20px;\n  }\n\n\n  .login-change-form .field {\n    height: 80px;\n  }\n\n  .must-contain-wrapper {\n    width: 650px;\n    height: 259px;\n  }\n\n  .login-change-form {\n    width: 651px;\n  }\n\n  .login-change-form h2 {\n    font-size: 24px;\n    margin-top: 70px;\n    margin-bottom: 30px;\n  }\n\n  .add-ip-code input {\n    width: 80px;\n    height: 45px;\n  }\n\n  .ip-dot {\n    width: 7px;\n    height: 7px;\n    margin-top: 36px;\n  }\n\n  .change-pin-wraper .field label::before {\n    content: attr(title);\n    position: absolute;\n    top: 30px;\n    left: 40px;\n  }\n\n  .twofa-guide-button button {\n    margin-top: 20px;\n    font-size: 20px;\n  }\n\n  .twofa-enable-wrapper h4 {\n    font-size: 28px;\n    color: #383838;\n    margin-bottom: 0px;\n  }\n\n  h4.get-appstore-playstore{\n    font-size: 18px;\n    color: #717171;\n  }\n\n  .download-authenticator-wrap .playstore img {\n    width: 86px;\n    height: 86px;\n  }\n\n  .login-change-form input {\n    font-size: 18px;\n  }\n}\n\n.pin-code-twofa input {\n  border-radius: 8px;\n  outline: none;\n}\n\n@media (max-width: 400px) {\n  .pin-code-twofa input {\n    border-radius: 8px;\n    outline: none;\n    text-align: center;\n    width: 42px;\n    height: 50px;\n    font-size: 30px;\n    background-color: #F8F8F8;\n    margin-right: 0px;\n    color: #383838;\n  }\n}\n\n@media (max-width: 300px) {\n  .pin-code-twofa input {\n    border: 1px solid #707070;\n    border-radius: 8px;\n    outline: none;\n    text-align: center;\n    width: 38px;\n    height: 50px;\n    font-size: 20px;\n    background-color: #fff;\n    margin-right: -2px;\n    color: #383838;\n  }\n}\n\n@media (min-width: 1600px) {\n  .login-change-form .label-before,\n  .login-change-form .field input:focus + label::before,\n  .login-change-form .field input:valid + label::before {\n    color: #707070;\n    line-height: 20px;\n    font-size: 18px;\n    top: -10px;\n  }\n\n  .login-change-form .label {\n    font-size: 18px;\n  }\n\n  .change-pin-wraper .field label::before {\n    font-size: 18px;\n  }\n\n  .login-change-form input {\n    font-size: 20px;\n    margin-top: 8px;\n    padding-left: 50px;\n    padding-top: 12px;\n  }\n\n  .field.up-text label::before {\n    color: #707070;\n    line-height: 20px;\n    font-size: 18px;\n    top: -10px;\n    background: #fff !important;\n    padding: 0 6px;\n    left: 9px;\n    font-weight: 400;\n  }\n\n}\n\n\n\n/************ KYC Page css Start Here For more Importance ******/\n.change-pin-wrapper{\n  padding-top: 0px;\n}\n\n.change-password-wrapper{\n  padding-top: 80px;\n}\n\n/* .navbar-space-wrapper{\n  padding-top: 80px;\n} */\n\n.kyc-requirement-wrapper {\n  /* text-align: center; */\n  border: none;\n  box-shadow: none;\n  width: 400px;\n  margin: 0 auto;\n  margin-top: 20px;\n  border-radius: 19px;\n  min-height: 150px;\n  background: #F8FBFE;\n  width: 650px;\n  height: 376px;\n}\n\n\np.kyc-text {\n  font-size: 28px;\n  width: 50%;\n  font-family: 'Montserrat';\n  color: #383838;\n  margin: 0 auto;\n  font-weight: 500;\n  margin-bottom: 80px;\n  margin-top: 35px;\n}\n\n\n.twofa-header.kyc-verification-header {  \n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n\n.twofa-header h3 {\n  font-size: 38px;\n  margin: 0px;\n}\n\n.twofa-header.kyc-verification-header img {\n  width: 141px;\n}\n\n\n.requirement-wrapper h4 {\n  font-size: 22px;\n  color: #383838;\n  font-family: 'Montserrat';\n  font-weight: 500;\n  margin-top: 25px;\n  margin-bottom:40px;\n}\n\n\nimg.kyc-status-review {\n  width: 300px;\n  height: auto;\n}\n\np.twofa-status.status-text {\n  font-size: 40px;\n  color: #383838;\n  font-family: 'Montserrat';\n}\n\n\np.review-time {\n  font-size: 26px;\n  color: #9E9E9E;\n}\n\n.twofa-footer.kyc-review-footer .twofa-security-wrapper{\n  border-bottom: none;\n}\n\n\n\n@media(max-width: 767px){\n  .kyc-requirement-wrapper {\n      width: 85%;\n      height: 300px;\n  }\n\n  .twofa-guide-button button{\n      width: 100%;\n      height: 55px;\n  }\n\n  p.kyc-text {\n      font-size: 18px;\n      width: 100%;\n      margin-bottom: 90px;\n      margin-top: 35px;\n  }\n\n  .twofa-header h3 {\n      font-size: 24px;\n  }\n\n  .twofa-header.kyc-verification-header img {\n      width: 94px;\n  }\n\n  .requirement-wrap p {\n      font-size: 18px;\n  }\n\n\n  .requirement-wrapper h4 {\n      font-size: 20px;\n      margin-top: 10px;\n      margin-bottom: 30px;\n  }\n\n  .navbar-space-wrapper {\n      padding-top: 80px;\n  }\n\n  .change-password-wrapper {\n      padding-top: 80px;\n  }\n\n  .requirement-wrapper{\n      margin-left: 0px;\n      margin-bottom: 80px;\n  }\n\n  .requirement-wrap {\n      margin-bottom: 25px;\n  }\n\n\n  .twofa-guide-button {\n      text-align: center;\n      margin-top: 20px;\n  }\n\n  img.kyc-status-review {\n      width: 230px;\n      height: auto;\n  }\n\n  p.twofa-status.status-text {\n      width: 100%;\n      font-size: 26px;\n  }\n\n  p.review-time {\n      font-size: 16px;\n  }\n\n  .reivew-wrap{\n      margin-top: 14px;\n  }\n\n  .reivew-wrap img {\n      width: 20px;\n      height: auto;\n  }\n\n  .twofa-security-wrap img {\n      width: 23px;\n      height: 23px;\n  }\n\n\n  .reivew-wrap {\n      gap: 8px;\n      /* margin-top: -24px; */\n  }\n\n  .twofa-status-wrapper {\n      margin-bottom: 60px;\n  }\n\n  .kyc-decline-space{\n      margin-bottom: 120px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px){\n  p.kyc-text {\n      font-size: 20px;\n      width: 70%;\n      margin-bottom: 30px;\n      margin-top: 20px;\n  }\n\n  .requirement-wrap {\n      margin-bottom: 22px;\n  }\n\n  .kyc-requirement-wrapper {\n      border: none;\n      box-shadow: none;\n      width: 550px;\n      height: 270px;\n  }\n\n  .requirement-wrapper h4 {\n      font-size: 20px;\n      margin-top: 5px;\n      margin-bottom: 20px;\n  }\n\n  .requirement-wrap p {\n      font-size: 18px;\n  }\n\n  .twofa-security-wrap {\n      width: 550px;\n  }\n\n  .twofa-guide-button button{\n      width: 550px;\n      height: 60px;\n  }\n\n  .twofa-security-wrap p {\n      font-size: 16px;\n      text-align: left;\n  }\n\n  .twofa-header h3 {\n      font-size: 30px;\n      margin: 0px;\n  }\n\n  .twofa-header {\n      text-align: center;\n      padding: 20px;\n  }\n\n  img.kyc-status-review {\n      width: 220px;\n      height: auto;\n  }\n\n  p.twofa-status.status-text {\n      font-size: 34px;\n  }\n\n  p.review-time {\n      font-size: 22px;\n  }\n\n  .twofa-footer.kyc-review-footer{\n      bottom: 30px !important;\n  }\n\n  .twofa-security-wrapper{\n      padding-bottom: 20px;\n  }\n\n  .twofa-guide-button {\n      margin-top: 20px;\n  }\n}\n\n\n@media (min-width: 1024px) and (max-width: 1599px){\n  p.kyc-text {\n      font-size: 22px;\n      width: 55%;\n      margin-bottom: 30px;\n      margin-top: 20px;\n  }\n\n  .requirement-wrap {\n      margin-bottom: 22px;\n  }\n\n\n  .kyc-requirement-wrapper {\n      border: none;\n      box-shadow: none;\n      width: 550px;\n      height: 270px;\n  }\n\n  .requirement-wrapper h4 {\n      font-size: 20px;\n      margin-top: 5px;\n      margin-bottom: 20px;\n  }\n\n  .requirement-wrap p {\n      font-size: 18px;\n  }\n\n  .twofa-security-wrap {\n      width: 550px;\n  }\n\n  .twofa-guide-button button{\n      width: 550px;\n      height: 60px;\n  }\n\n  .twofa-security-wrap p {\n    font-size: 14px;\n    text-align: left;\n  }\n\n  .twofa-header h3 {\n      font-size: 30px;\n      margin: 0px;\n  }\n\n  .twofa-header {\n      text-align: center;\n      padding: 20px;\n  }\n\n  img.kyc-status-review {\n      width: 220px;\n      height: auto;\n  }\n\n  p.twofa-status.status-text {\n      font-size: 34px;\n  }\n\n  p.review-time {\n      font-size: 22px;\n  }\n\n  .twofa-footer.kyc-review-footer{\n      bottom: 30px !important;\n  }\n\n  .twofa-security-wrapper{\n    padding-bottom: 12px;\n  }\n\n  .twofa-guide-button {\n      margin-top: 20px;\n  }\n}\n\n@media(min-width: 1600px){\n  .twofa-footer.kyc-review-footer{\n      bottom: 50px !important;\n  }\n\n  .twofa-header.kyc-verification-header {  \n      height: 105px;\n  }\n\n}\n\n.accented {\n  accent-color: #00A19B;\n}\n\n\n.for-space-disaper-button{\n  opacity: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
